let authRun = ($rootScope, $state, $window, OAuth, sharedService) => {
  "ngInject";
  $rootScope.$on('oauth:error', function (event, rejection) {

    // Ignore `invalid_grant` error - should be catched on `LoginController`.
    if ('invalid_grant' === rejection.data.error && 400 === rejection.status && $state.is('auth.login')) {
      return;
    }

    // Refresh token when a `invalid_token` error or a `invalid_grant` error and status 400 occurs
    if ('invalid_token' === rejection.data.error || (
        // Patch related with: https://github.com/oauthjs/angular-oauth2/issues/32
        401 === rejection.status && 'invalid_grant' === rejection.data.error
      )) {
      if (sharedService.refreshingToken) {
        return;
      }
      sharedService.refreshingToken = true;
      return OAuth.getRefreshToken().then(() => {
        sharedService.refreshingToken = false;
        $state.reload('home');
      });
    }

    // Redirect to `/login` with the `error_reason`.
    $state.go('auth.login', {'error_reason': rejection.data.error});
    event.preventDefault();
  });

  $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
    if (!OAuth.isAuthenticated() && toState.name !== 'auth.login') {
      // User isn’t authenticated
      $state.go('auth.login');
      event.preventDefault();
    }
  });
};

export default authRun;



// WEBPACK FOOTER //
// ./client/app/common/auth/auth.run.js